<template>
  <div class="col-lg-6">
    <div class="login-wrapper">
      <h2 class="account-h2 u-s-m-b-20">Login</h2>
      <h6 class="account-h6 u-s-m-b-30">
        Welcome back! Sign in to your account.
      </h6>
      <form @submit.prevent="handleSubmit">
        <div v-if="status.login_meta_data.metadata.status != 'otp_sent' && status.login_meta_data.metadata.status != 'error'">
          <div class="u-s-m-b-30">
          <label for="user-name-email"
            >Email
            <span class="astk">*</span>
          </label>
          <input
            type="text"
            id="user-name-email"
            class="text-field"
            placeholder="Email"
            v-model="email"
            required
            autocomplete="off"
          />
          <h6 class="account-h6 u-s-m-b-30 mt-1" style="color: red" v-if="status.login.error.nokey || status.login.error.email">{{status.login.error.nokey || status.login.error.email[0]}}</h6>
        </div>
        <div class="u-s-m-b-30">
          <label for="login-password"
            >Password
            <span class="astk">*</span>
          </label>
          <input
            type="password"
            id="login-password"
            class="text-field"
            placeholder="Password"
            v-model="password"
            required
            autocomplete="off"
          />
           <h6 class="account-h6 u-s-m-b-30 mt-1" style="color: red" v-if="status.login.error.password">{{status.login.error.password[0]}}</h6>
        </div>
        <div>
           <div class="u-s-m-b-30" v-if="status.login_meta_data.metadata.status == 'no_phone' || showPhoneNumberField">
          <label for="phone-number"
            >Phone Number
            <span class="astk">*</span>
          </label>
          <input
            type="text"
            id="phone-number"
            class="text-field"
            placeholder="Phone Number"
            v-model="phone_number"
            required
            autocomplete="off"
            minlength="10"
            maxlength="10"
          />
           <h6 class="account-h6 u-s-m-b-30 mt-1" style="color: red">{{status.login_meta_data.metadata.message}}</h6>
        </div>
        </div>
        <div class="group-inline u-s-m-b-30">
          <div class="group-1">
            <input type="checkbox" class="check-box" id="remember-me-token" />
            <label class="label-text" for="remember-me-token"
              >Remember me</label
            >
          </div>
          <div class="group-2 text-right">
            <div class="page-anchor">
              <router-link :to="{name : 'ForgotPassword'}"> <i class="fas fa-circle-o-notch u-s-m-r-9"></i>Lost your
                password?</router-link>
            </div>
          </div>
        </div>
        </div>
        <div v-else>
           <div class="u-s-m-b-30">
          <label for="phone-number"
            >OTP
            <span class="astk">*</span>
          </label>
          <input
            type="number"
            id="phone-number"
            class="text-field"
            placeholder="Please Enter OTP"
            v-model="otp"
            required
            autocomplete="off"
          />
           <h6 class="account-h6 u-s-m-b-30 mt-1" style="color: red">{{status.login_meta_data.metadata.message}}</h6>
        </div>
        <div class="page-anchor mb-3">
          <a href="#" @click="handleBackToLogin">
             <i class="fas fa-long-arrow-alt-left u-s-m-r-9" ></i>Back to Login
          </a>
        </div>
        </div>
        <div class="m-b-45">
          <button class="button button-outline-secondary w-100" :disabled="status.login.loading">{{status.login.loading ? "Please Wait." : "Login"}}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: { ...mapGetters("auth", ["status"]) },
  methods: {
    ...mapActions("auth", ["login"]),
    handleSubmit() {
      this.login({ email: this.email, password: this.password, phone_no : this.phone_number, otp : this.otp });
    },
    handleBackToLogin(){
     this.status.login_meta_data.metadata.status = '';
     this.status.login_meta_data.metadata.message = '';
     this.otp = "";
     this.showPhoneNumberField = true;
    },
    scroll() {
      const el = document.getElementsByClassName("container")[0];
      this.$smoothScroll({
        scrollTo: el, // scrollTo is also allowed to be number
      });
    },
  },
  data() {
    return {
      email: "",
      password: "",
      phone_number : "",
      otp : "",
      showPhoneNumberField : false,
    };
  },
  unmounted(){
    if(this.status.login_meta_data.metadata){
      this.status.login_meta_data.metadata = '';
    }
    if(this.status.register_meta_data.metadata){
      this.status.register_meta_data.metadata = ""
    }
  }
};
</script>

<style>
</style>
